<div class="page personal-info">
  <h1 class="c-h1">{{ 'personal-information' | translate }}</h1>

  <!-- Identity Section -->
  <section class="info-section">
    <div class="info-section__header">
      <div class="info-section__icon">
        <i class="fa fa-address-card"></i>
      </div>
      <h3 class="info-section__title">{{ 'PERSONAL_DATA.PERSONAL_INFORMATION.identity' | translate }}</h3>
    </div>
    <myabvv-personal-information-identification [inss]="member()?.personalInformation?.inss"
                                                [nationality]="getTranslatedData(member()?.personalInformation?.nationality)"
                                                [gender]="getTranslatedData(member()?.personalInformation?.gender)"
                                                [motherLanguage]="member()?.personalInformation?.motherLanguage"
                                                [maritalStatus]="getTranslatedData(member()?.personalInformation?.maritalStatus)"
                                                [firstName]="member()?.personalInformation?.firstName"
                                                [lastName]="member()?.personalInformation?.lastName">
    </myabvv-personal-information-identification>
  </section>

  <!-- Address Section -->
  <section class="info-section">
    <div class="info-section__header">
      <div class="info-section__icon">
        <i class="fa fa-home"></i>
      </div>
      <h3 class="info-section__title">{{ 'PERSONAL_DATA.PERSONAL_INFORMATION.address' | translate }}</h3>
    </div>
    <myabvv-personal-information-address [street]="member()?.personalInformation?.addresses[0]?.street"
                                         [houseNumber]="member()?.personalInformation?.addresses[0]?.houseNumber"
                                         [boxNumber]="member()?.personalInformation?.addresses[0]?.boxNumber"
                                         [city]="member()?.personalInformation?.addresses[0]?.city"
                                         [zipCode]="member()?.personalInformation?.addresses[0]?.zipCode"
                                         [country]="getTranslatedData(member()?.personalInformation?.addresses[0]?.countryCode)">
    </myabvv-personal-information-address>
  </section>

  <!-- Bank Account Section -->
  <section class="info-section">
    <div class="info-section__header">
      <div class="info-section__icon">
        <i class="fa fa-university"></i>
      </div>
      <h3 class="info-section__title">{{ 'PERSONAL_DATA.PERSONAL_INFORMATION.bank_information' | translate }}</h3>
    </div>
    <myabvv-personal-information-bank-account [bankAccount]="member()?.personalInformation?.bankAccounts[0]">
    </myabvv-personal-information-bank-account>
  </section>

  <!-- Contact Info Section -->
  <section class="info-section">
    <div class="info-section__header">
      <div class="info-section__icon">
        <i class="fa fa-comments"></i>
      </div>
      <h3 class="info-section__title">{{ 'PERSONAL_DATA.PERSONAL_INFORMATION.PERSONAL_INFORMATION_CONTACTINFO.contact_info' | translate }}</h3>
    </div>
    <myabvv-personal-information-contact [member]="member()" (updatePersonalInformationEvent)="onUpdateMember($event)"
                                         [serverErrors]="updateServerErrors()" [isUpdating]="isUpdating()">
    </myabvv-personal-information-contact>
  </section>

  <!-- Contribution Section -->
  <section class="info-section">
    <div class="info-section__header">
      <div class="info-section__icon">
        <i class="fa fa-newspaper"></i>
      </div>
      <h3 class="info-section__title">{{ 'FINANCIAL.latest_contribution' | translate }}</h3>
    </div>
    @if (membershipState$ | async; as state) {
      @if (state.data) {
        <myabvv-personal-information-contribution [central]="getTranslatedData(state.data.central)"
                                                  [region]="getTranslatedData(state.data.region)"
                                                  [subRegion]="getTranslatedData(state.data.subRegion)"
                                                  [lastMonthOfContribution]="state.data.lastMonthOfContribution">
        </myabvv-personal-information-contribution>
      }
    }
  </section>
</div>
